import { createFileRoute } from '@tanstack/react-router';
import { PainelAdministrativoComandoSqlPage } from '@/features/painel-administrativo/sql/page/PainelAdministrativoComandoSqlPage';

export const Route = createFileRoute('/admin/_a/sql')({
    component: PainelAdministrativoComandoSqlPage,
});
